// Insights API — «Инсайты о Вас» (spec §2.8, v2.5). The screens read the
// engine state through GET /engine/insights: no LLM, no report generator.
// 409 means the user is not engine-enabled yet (pre-payment) — callers
// render the subscription empty state.

import { api } from './client'
import type { InsightsResponse } from '../types/api'

export type InsightsScreen = 'quotes' | 'progress' | 'themes' | 'strengths' | 'self_view'

export const insightsApi = {
  get: (screen?: InsightsScreen) =>
    api.get<InsightsResponse>(`/engine/insights${screen ? `?screen=${screen}` : ''}`),
  // Hide one card forever (§2.8 rule 8): kind is the screen, id the card.
  hide: (kind: Exclude<InsightsScreen, 'progress'>, id: string) =>
    api.post<{ status: string; kind: string; id: string }>('/engine/insights/hide', { kind, id }),
}
